import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import PropTypes from 'prop-types';

// Placeholder that mirrors Product.jsx's geometry - same image aspect ratio, same padding, same
// number of text lines - so the grid doesn't jump when the real cards arrive.
export default function ProductCardSkeleton({ compact = false }) {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        backgroundColor: 'background.default',
        overflow: 'hidden'
      }}>
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          width: '100%',
          aspectRatio: compact ? '1 / 1' : '4 / 5',
          backgroundColor: 'background.paper'
        }}
      />

      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: compact ? 1 : { xs: 1.25, md: 1.75 }
        }}>
        {/* Two title lines, then one EUR price line. */}
        <Skeleton animation="wave" width="90%" height={compact ? 14 : 18} />
        <Skeleton animation="wave" width="65%" height={compact ? 14 : 18} />
        <Box sx={{ mt: 'auto', pt: 1, width: '100%', display: 'grid', justifyItems: 'center' }}>
          <Skeleton animation="wave" width="55%" height={compact ? 14 : 18} />
        </Box>
      </Box>
    </Box>
  );
}

ProductCardSkeleton.propTypes = {
  compact: PropTypes.bool
};
